import { graphql } from 'react-relay';

import createMutation from '../../../../relay/createMutation';

const mutation = graphql`
  mutation UpdateTutoringCompanyMutation(
    $input: UpdateTutoringCompanyMutationInput!
  ) {
    updateTutoringCompany(input: $input) {
      clientMutationId
      tutoringCompany {
        id
        ...EditTutoringCompany_company
      }
    }
  }
`;

export default variables => createMutation(mutation)(variables);



// WEBPACK FOOTER //
// ./src/modules/admin/company/mutations/UpdateTutoringCompanyMutation.js